import { render } from "./InputGhgEmission.vue?vue&type=template&id=189a6bd0&scoped=true"
import script from "./InputGhgEmission.vue?vue&type=script&lang=ts"
export * from "./InputGhgEmission.vue?vue&type=script&lang=ts"

import "./InputGhgEmission.vue?vue&type=style&index=0&id=189a6bd0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-189a6bd0"

export default script